import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ColorPicker from '../../ColorPicker/ColorPicker';

interface OverlayColorSectionProps {
  overlayColor: string;
  onOverlayColorChange: (color: string) => void;
}

export default function OverlayColorSection({
  overlayColor,
  onOverlayColorChange,
}: OverlayColorSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
        sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
      >
        {t('createGuiVersionPage.overlayColor')}
        <ColorPicker value={overlayColor} onChange={onOverlayColorChange} />
      </Typography>
    </Grid>
  );
}
